module.exports = __webpack_public_path__ + "img/icon_pin.a4aeaade.svg";